import APCheckbox from './APCheckbox.js';
import { InnerCheckboxInput } from './APCheckbox.js';
export { InnerCheckboxInput };
export default APCheckbox;